<template>
  <div>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col>
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "dashboard-view",
};
</script>
